<template>
  <button :class="[back ? 'back' : 'forward', dark ? 'is-dark' : '']" @click="$emit('click')">
    <svg width="15" height="14" viewBox="0 0 15 14">
      <path d="M7.514 14l-7-7 7-7 1.237 1.237L3.867 6.14h10.647v1.718H3.867l4.884 4.904z" fill-rule="evenodd"/>
    </svg>
  </button>
</template>

<script>
export default {
  name: "LinearButton",
  components: {},
  props: { back: Boolean, dark:Boolean },
};
</script>


<style lang="scss" scoped>
button {  
  outline: none;
  height: 65px;
  width: 65px;
  box-sizing: border-box;
  border-radius: 3px;
  

  text-decoration: none;
  color: #fff;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;

  font-family: "Gotham";
  font-size: 1em;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1em;

  position: relative;
  top: 50%;
  transform: translateY(-50%);
  
  
  width: 64.2px;
  
  margin-right: 20px;
  pointer-events: all;
  transition: border 0.25s cubic-bezier(1, 0.5, 0.8, 1);
  cursor: pointer;
  border: 1px solid transparent;
  &.is-dark {
    background: rgba(#0B0B0B, 0.7);
    border: 1px solid #fff;
    svg path {
      fill:#fff;
      transition: fill 0.25s cubic-bezier(1, 0.5, 0.8, 1);
    }
    &:hover {
      border: 1px solid #ffd62f;
      svg path {
        fill:#ffd62f;
      }
    }
  }
  &:not(.is-dark) {
    background: linear-gradient(180deg, #FFFFFF 0.38%, #9E9E9E 99.68%);
    border: 1px solid #252525;
    svg path {
      fill:#2E2E30;
    }
    &:hover {
      border: 1px solid #ffd62f;
    }
  }
  &:not(:last-child) {
    margin-right: 10px;
  }  
  &.forward svg {
    transform: scaleX(-1);
  }
}
</style>
